import React, { Component } from 'react';

type ErrorBoundaryProps = {
    fallback: React.ReactNode;
} & React.PropsWithChildren;

type ErrorBoundaryState = {
    hasError: boolean;
};

export class ErrorBoundary extends Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        // oxlint-disable-next-line no-console
        console.error(error);
        window.telemetry?.logUnknownError({ source: 'ErrorBoundary' }, error);
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.fallback;
        }

        return this.props.children;
    }
}
